export default __webpack_public_path__ + "static/media/Icon-01.fc50187a.svg";